import {
	CreateDrawerFormProps,
	FormDrawer,
	FormDrawerContent,
	FormDrawerContentProps,
	FormFetchDrawer,
	TextField,
	UpdateDrawerFormProps,
} from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { distributionListService } from "../shared/api/distributionListService";
import { IDistributionListFormState } from "../shared/types";

const useValidate = () => {
	const { t } = useTranslation();

	return (values: IDistributionListFormState) => {
		const errors: { [K in keyof IDistributionListFormState]?: any } = {};

		if (!values.name) {
			errors.name = t("Required field");
		}

		return errors;
	};
};

const DistributionListFormDrawerContent: FC<FormDrawerContentProps> = (props) => {
	const { t } = useTranslation();

	return (
		<FormDrawerContent {...props}>
			<TextField name="name" label={t("Name")} required />
		</FormDrawerContent>
	);
};

export const DistributionListCreateDrawer: FC<CreateDrawerFormProps<IDistributionListFormState>> = (props) => {
	const { t } = useTranslation();
	const validate = useValidate();
	const initialValues: IDistributionListFormState = {
		name: "",
		description: "",
	};

	return (
		<FormDrawer
			{...props}
			initialValues={initialValues}
			title={t("Add distribution list")}
			validate={validate}
			renderForm={(props) => <DistributionListFormDrawerContent {...props} />}
		/>
	);
};

export const DistributionListUpdateDrawer: FC<UpdateDrawerFormProps<IDistributionListFormState>> = (props) => {
	const { t } = useTranslation();
	const validate = useValidate();

	return (
		<FormFetchDrawer
			{...props}
			title={t("Edit distribution list")}
			queryFn={() => distributionListService.show(props.id).then((x) => x.data.data)}
			queryKey={distributionListService.showKey(props.id)}
			validate={validate}
			renderSuccess={(props) => <DistributionListFormDrawerContent {...props} />}
		/>
	);
};
